import React from 'react'

class Circle extends React.Component {
  render() {
    return (
      <svg className="circle" width="12" height="12" viewBox="0 0 12 12">
        <rect
          width="10"
          height="10"
          x="344"
          y="432"
          fill="none"
          fillRule="nonzero"
          stroke="#CCC"
          strokeWidth="1.8"
          rx="5"
          transform="translate(-343 -431)"
        />
      </svg>
    )
  }
}

export default Circle
